export * from './declaracao-de-autonomo-e-renda';